import { create } from 'zustand';

export type LogLevel = 'log' | 'info' | 'warn' | 'error';

export interface LogEntry {
  id: number;
  level: LogLevel;
  message: string;
  timestamp: number;
}

interface LogState {
  entries: LogEntry[];
  append: (level: LogLevel, args: unknown[]) => void;
  clear: () => void;
}

const MAX_ENTRIES = 500;
let nextId = 1;

function formatArgs(args: unknown[]): string {
  return args
    .map((a) => {
      if (typeof a === 'string') {
        return a;
      }
      if (a instanceof Error) {
        return a.message;
      }
      try {
        return JSON.stringify(a);
      } catch {
        return String(a);
      }
    })
    .join(' ');
}

export const useLogStore = create<LogState>((set) => ({
  entries: [],
  append: (level, args) =>
    set((s) => {
      const entry: LogEntry = {
        id: nextId++,
        level,
        message: formatArgs(args),
        timestamp: Date.now(),
      };
      const entries = [...s.entries, entry];
      if (entries.length > MAX_ENTRIES) {
        entries.splice(0, entries.length - MAX_ENTRIES);
      }
      return { entries };
    }),
  clear: () => set({ entries: [] }),
}));
